import React, { useEffect, useState } from "react";
import {
  addServiceDashboard,
  addStaffDashboard,
  completeProfileDashboardGoogle,
  getBusinessDashboard,
  getBusinessProfile,
  getBusinessServices,
} from "../logic/business/action";
import { useDispatch, useSelector } from "react-redux";
import {
  MdClose,
  MdDelete,
  MdCheckCircle,
  MdAdd,
  MdArrowForward,
  MdBusiness,
  MdPeople,
  MdSettings,
  MdPhone,
  MdLocationOn,
} from "react-icons/md";
import logo from "../images/logo_clock.png";
import { Link, useNavigate } from "react-router-dom";
import { getCategories } from "../logic/categories/action";
import { logOut } from "../logic/login/action";
import { Formik, Form } from "formik";
import {
  feildsAddStaff,
  initialValuesAddStaff,
  validationSchemaAddStaff,
} from "../fromsUtil/addStaff";
import {
  feildsUpdateProfileGoogle,
  initialValuesUpdateProfileGoogle,
  validationSchemaUpdateProfileGoogle,
} from "../fromsUtil/updateProfile";
import { motion, AnimatePresence } from "framer-motion";
import ThreeBackground from "../components/ThreeBackground";
import ModernInput from "../components/ModernInput";
import {
  Button,
  Box,
  Typography,
  Divider,
  IconButton,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  Card,
  CardContent,
  LinearProgress,
} from "@mui/material";
import { CircularProgress } from "@mui/material";

const CompleteSetupGoogle = () => {
  const selector = useSelector((state) => state.business);
  const selectorAuth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const nav = useNavigate();

  const [serviceDrop, setserviceDrop] = useState(false);
  const [staffDrop, setstaffDrop] = useState(false);
  const [profileDrop, setprofileDrop] = useState(false);

  useEffect(() => {
    getBusinessProfile(dispatch);
    getBusinessDashboard(dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (
      selector.dashboard?.isCompleted === true &&
      selector.dashboard?.totalService > 0 &&
      selector.dashboard?.totalStaff > 0
    ) {
      nav("/admin/qrCode");
    }
  }, [selector.dashboard, nav]);

  const steps = [
    {
      id: 1,
      title: "Business Setup",
      description: "Update your profile information",
      icon: <MdBusiness className="text-2xl" />,
      isCompleted: selector.dashboard?.isCompleted,
      disabled: false,
      onClick: () => setprofileDrop(true),
      btnText: "Complete Profile",
    },
    {
      id: 2,
      title: "Services",
      description: "Add services with charges",
      icon: <MdSettings className="text-2xl" />,
      isCompleted: selector.dashboard?.totalService > 0,
      disabled: !selector.dashboard?.isCompleted,
      onClick: () => setserviceDrop(true),
      btnText: "Add Service",
    },
    {
      id: 3,
      title: "Staff",
      description: "Add staff details to generate your QR code",
      icon: <MdPeople className="text-2xl" />,
      isCompleted: selector.dashboard?.totalStaff > 0,
      disabled:
        !selector.dashboard?.isCompleted ||
        selector.dashboard?.totalService <= 0,
      onClick: () => setstaffDrop(true),
      btnText: "Add Staff",
    },
  ];

  const completedSteps = steps.filter((step) => step.isCompleted).length;
  const progress = (completedSteps / steps.length) * 100;

  return (
    <div className="w-full h-screen bg-gradient-to-br from-[#667eea] via-[#764ba2] to-[#0B469D] relative overflow-x-hidden">
      <ThreeBackground />

      {/* Popups */}
      <AnimatePresence>
        {serviceDrop && (
          <ServicePopup closePopup={() => setserviceDrop(false)} />
        )}
        {staffDrop && <StaffPopup closePopup={() => setstaffDrop(false)} />}
        {profileDrop && (
          <ProfilePopup closePopup={() => setprofileDrop(false)} />
        )}
      </AnimatePresence>

      {/* Header */}
      <motion.header
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="w-full lg:w-[90%] mx-auto flex items-center py-6 justify-between px-4 lg:px-8 relative z-10"
      >
        <motion.a
          href="/"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <img src={logo} className="w-20 h-20 drop-shadow-lg" alt="Logo" />
        </motion.a>
        <div className="flex items-center gap-4">
          <a
            href="mailto:team@theappointmentapp.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:inline-block"
          >
            <motion.p
              whileHover={{ scale: 1.05 }}
              className="text-white/90 hover:text-white transition-colors"
            >
              team@theappointmentapp.com
            </motion.p>
          </a>
          <Link to={"/admin/login"} onClick={() => logOut(dispatch)}>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Button
                variant="outlined"
                sx={{
                  color: "white",
                  borderColor: "rgba(255, 255, 255, 0.5)",
                  borderRadius: "12px",
                  px: 3,
                  py: 1,
                  "&:hover": {
                    borderColor: "white",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  },
                }}
              >
                Login
              </Button>
            </motion.div>
          </Link>
        </div>
      </motion.header>

      {/* Main Content */}
      <div className="w-full h-[calc(100vh-96px)] lg:w-[90%] mx-auto px-4 lg:px-8 py-8 relative z-10 flex items-center justify-center overflow-y-auto overflow-x-hidden">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-5xl overflow-x-hidden"
        >
          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(20px)",
              borderRadius: "24px",
              padding: { xs: 3, sm: 4, md: 5 },
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              maxHeight: "calc(100vh - 200px)",
              marginY: 3,
            }}
          >
            {/* Header Section */}
            <div className="mb-8">
              <Typography variant="h4" className="font-bold text-gray-800 mb-2">
                Complete your setup
              </Typography>
              <Typography variant="body2" className="text-gray-600 mb-4">
                Let's finish your setup to get started with your business
              </Typography>

              {/* Progress Bar */}
              <div className="mb-2">
                <div className="flex items-center justify-between mb-2">
                  <Typography variant="body2" className="text-gray-600">
                    Progress
                  </Typography>
                  <Typography
                    variant="body2"
                    className="font-semibold text-[#0B469D]"
                  >
                    {completedSteps} of {steps.length} completed
                  </Typography>
                </div>
                <LinearProgress
                  variant="determinate"
                  value={progress}
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: "#e5e7eb",
                    "& .MuiLinearProgress-bar": {
                      borderRadius: 4,
                      background:
                        "linear-gradient(90deg, #0B469D 0%, #72a9fb 100%)",
                    },
                  }}
                />
              </div>
            </div>

            {/* Steps Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 overflow-x-hidden">
              {steps.map((step, index) => (
                <SetupCard
                  key={step.id}
                  step={step}
                  index={index}
                  isLast={index === steps.length - 1}
                />
              ))}
            </div>
          </Box>
        </motion.div>
      </div>
    </div>
  );
};

const SetupCard = ({ step, index, isLast }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="relative"
    >
      <Card
        sx={{
          height: "100%",
          borderRadius: "16px",
          border: step.isCompleted
            ? "2px solid #10b981"
            : step.disabled
            ? "2px solid #e5e7eb"
            : "2px solid #0B469D",
          boxShadow: step.isCompleted
            ? "0 8px 25px rgba(16, 185, 129, 0.2)"
            : step.disabled
            ? "0 2px 8px rgba(0, 0, 0, 0.1)"
            : "0 8px 25px rgba(11, 70, 157, 0.2)",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: step.disabled ? "none" : "translateY(-4px)",
            boxShadow: step.disabled
              ? "0 2px 8px rgba(0, 0, 0, 0.1)"
              : "0 12px 35px rgba(11, 70, 157, 0.3)",
          },
        }}
      >
        <CardContent sx={{ p: 3 }}>
          {/* Step Number & Icon */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                  step.isCompleted
                    ? "bg-green-500"
                    : step.disabled
                    ? "bg-gray-300"
                    : "bg-[#0B469D]"
                }`}
              >
                {step.isCompleted ? (
                  <MdCheckCircle className="text-white text-2xl" />
                ) : (
                  <span
                    className={`font-bold text-lg ${
                      step.disabled ? "text-gray-500" : "text-white"
                    }`}
                  >
                    {step.id}
                  </span>
                )}
              </div>
              <div
                className={`p-2 rounded-lg ${
                  step.isCompleted
                    ? "bg-green-100 text-green-600"
                    : step.disabled
                    ? "bg-gray-100 text-gray-400"
                    : "bg-blue-100 text-[#0B469D]"
                }`}
              >
                {step.icon}
              </div>
            </div>
            {step.isCompleted && (
              <motion.span
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-semibold"
              >
                Done
              </motion.span>
            )}
          </div>

          {/* Title & Description */}
          <div className="mb-4">
            <Typography
              variant="h6"
              className={`font-bold mb-1 ${
                step.disabled ? "text-gray-400" : "text-gray-800"
              }`}
            >
              {step.title}
            </Typography>
            <Typography
              variant="body2"
              className={step.disabled ? "text-gray-400" : "text-gray-600"}
            >
              {step.description}
            </Typography>
          </div>

          {/* Action Button */}
          {!step.isCompleted && (
            <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
              <Button
                fullWidth
                disabled={step.disabled}
                onClick={step.onClick}
                variant="contained"
                sx={{
                  borderRadius: "10px",
                  py: 1.2,
                  textTransform: "none",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  background: step.disabled
                    ? "linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)"
                    : "linear-gradient(135deg, #0B469D 0%, #72a9fb 100%)",
                  boxShadow: step.disabled
                    ? "none"
                    : "0 4px 15px rgba(11, 70, 157, 0.3)",
                  "&:hover": {
                    background: step.disabled
                      ? "linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)"
                      : "linear-gradient(135deg, #0a3d7a 0%, #5a8fd8 100%)",
                    boxShadow: step.disabled
                      ? "none"
                      : "0 6px 20px rgba(11, 70, 157, 0.4)",
                  },
                }}
              >
                {step.btnText}
              </Button>
            </motion.div>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
};

const ServicePopup = ({ closePopup }) => {
  const selector = useSelector((state) => state.business);
  const dispatch = useDispatch();
  const [services, setservices] = useState([{ service: "", charges: "" }]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitService = async () => {
    if (services.length > 0) {
      let count = 0;
      for (let index = 0; index < services.length; index++) {
        const element = services[index];
        if (element.service === "" || element.charges === "") {
          count++;
        }
      }
      if (count > 0) {
        return;
      }
      setIsSubmitting(true);
      await addServiceDashboard(
        dispatch,
        services,
        selector.details?.business_id
      );
      setservices([{ service: "", charges: "" }]);
      setIsSubmitting(false);
      closePopup();
    }
  };

  return (
    <Dialog
      open={true}
      onClose={closePopup}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "24px",
          backgroundColor: "rgba(255, 255, 255, 0.98)",
          backdropFilter: "blur(20px)",
        },
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
      >
        <DialogTitle className="flex items-center justify-between border-b pb-3">
          <Typography variant="h5" className="font-bold">
            Add Services
          </Typography>
          <IconButton onClick={closePopup} sx={{ color: "#666" }}>
            <MdClose />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <div className="flex items-center justify-between mb-6">
            <Typography variant="body2" className="text-gray-600">
              Add your services and their charges
            </Typography>
            <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
              <IconButton
                onClick={() =>
                  setservices((prev) => [...prev, { service: "", charges: "" }])
                }
                sx={{
                  backgroundColor: "#0B469D",
                  color: "white",
                  "&:hover": { backgroundColor: "#0a3d7a" },
                }}
              >
                <MdAdd />
              </IconButton>
            </motion.div>
          </div>

          <div className="flex flex-col gap-4 max-h-[400px] overflow-y-auto overflow-x-hidden pr-2">
            {services.map((e, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.1 }}
                className="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full"
              >
                <TextField
                  fullWidth
                  label="Service Name"
                  value={e.service}
                  onChange={(ev) => {
                    const temp = [...services];
                    temp[i].service = ev.target.value;
                    setservices(temp);
                  }}
                  variant="outlined"
                  sx={{ flex: { xs: "1 1 100%", sm: "2 1 auto" }, minWidth: 0 }}
                />
                <TextField
                  label="Charges (₹)"
                  type="number"
                  value={e.charges}
                  onChange={(ev) => {
                    const temp = [...services];
                    temp[i].charges = ev.target.value;
                    setservices(temp);
                  }}
                  variant="outlined"
                  sx={{
                    flex: { xs: "1 1 100%", sm: "1 0 140px" },
                    minWidth: { xs: "100%", sm: "140px" },
                    maxWidth: { xs: "100%", sm: "140px" },
                  }}
                />
                <IconButton
                  onClick={() => {
                    setservices((prev) =>
                      prev.length > 1 ? prev.filter((el, iv) => iv !== i) : prev
                    );
                  }}
                  disabled={services.length === 1}
                  sx={{
                    backgroundColor: "#ef4444",
                    color: "white",
                    mt: { xs: 0, sm: 1 },
                    flexShrink: 0,
                    width: { xs: "100%", sm: "48px" },
                    height: { xs: "40px", sm: "48px" },
                    "&:hover": { backgroundColor: "#dc2626" },
                    "&.Mui-disabled": {
                      backgroundColor: "#e5e7eb",
                      color: "#9ca3af",
                    },
                  }}
                >
                  <MdDelete />
                </IconButton>
              </motion.div>
            ))}
          </div>

          <div className="flex items-center justify-center pt-6 border-t mt-6">
            <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
              <Button
                onClick={submitService}
                disabled={isSubmitting}
                variant="contained"
                endIcon={<MdArrowForward />}
                sx={{
                  borderRadius: "12px",
                  py: 1.5,
                  px: 4,
                  background:
                    "linear-gradient(135deg, #0B469D 0%, #72a9fb 100%)",
                  textTransform: "none",
                  fontSize: "1rem",
                  fontWeight: 600,
                  boxShadow: "0 8px 25px rgba(11, 70, 157, 0.3)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #0a3d7a 0%, #5a8fd8 100%)",
                    boxShadow: "0 12px 35px rgba(11, 70, 157, 0.4)",
                  },
                }}
              >
                {isSubmitting ? "Adding Services..." : "Save Services"}
              </Button>
            </motion.div>
          </div>
        </DialogContent>
      </motion.div>
    </Dialog>
  );
};

const StaffPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.business);
  const [selectedServices, setselectedServices] = useState([]);
  const [openservice, setopenservice] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getBusinessServices(dispatch, selector.details?.business_id);
  }, [dispatch, selector.details?.business_id]);

  const submitService = async (values) => {
    setIsSubmitting(true);
    await addStaffDashboard(dispatch, {
      ...values,
      services: selectedServices.join(","),
    });
    setIsSubmitting(false);
    closePopup();
  };

  return (
    <>
      <Dialog
        open={openservice}
        onClose={() => setopenservice(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            backgroundColor: "rgba(255, 255, 255, 0.98)",
          },
        }}
      >
        <DialogTitle className="border-b pb-3">
          <Typography variant="h6" className="font-bold">
            Select Services
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <div className="flex flex-col gap-3 py-4">
            <div className="flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 cursor-pointer border border-gray-200">
              <Typography className="font-semibold">All Services</Typography>
              <input
                checked={
                  selectedServices.length === selector.services?.length &&
                  selector.services?.length > 0
                }
                onChange={(ev) => {
                  if (Array.isArray(selector.services)) {
                    if (selectedServices.length === selector.services?.length) {
                      setselectedServices([]);
                    } else {
                      setselectedServices(
                        selector.services?.map((e) => e.service_id)
                      );
                    }
                  }
                }}
                type="checkbox"
                className="w-5 h-5 cursor-pointer"
              />
            </div>
            {selector.services?.map((e, i) => (
              <div
                key={i}
                className="flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 cursor-pointer border border-gray-200"
              >
                <Typography>{e.service}</Typography>
                <input
                  checked={selectedServices.includes(e.service_id)}
                  onChange={(ev) => {
                    if (selectedServices.includes(e.service_id)) {
                      setselectedServices((prev) =>
                        prev.filter((el) => el !== e.service_id)
                      );
                    } else {
                      setselectedServices((prev) => [...prev, e.service_id]);
                    }
                  }}
                  type="checkbox"
                  className="w-5 h-5 cursor-pointer"
                />
              </div>
            ))}
          </div>
          <div className="flex justify-center pt-4 border-t mt-4">
            <Button
              onClick={() => setopenservice(false)}
              variant="contained"
              sx={{
                borderRadius: "12px",
                px: 4,
                py: 1.2,
                background: "linear-gradient(135deg, #0B469D 0%, #72a9fb 100%)",
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Confirm Selection
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={true}
        onClose={closePopup}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            backgroundColor: "rgba(255, 255, 255, 0.98)",
            backdropFilter: "blur(20px)",
          },
        }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
        >
          <DialogTitle className="flex items-center justify-between border-b pb-3">
            <Typography variant="h5" className="font-bold">
              Add Staff Member
            </Typography>
            <IconButton onClick={closePopup} sx={{ color: "#666" }}>
              <MdClose />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <Formik
              initialValues={initialValuesAddStaff}
              validationSchema={validationSchemaAddStaff}
              onSubmit={submitService}
            >
              {({ isSubmitting: formSubmitting, isValid }) => (
                <Form className="flex flex-col gap-4">
                  {feildsAddStaff([
                    { value: "admin", label: "Admin", disabled: false },
                    { value: "staff", label: "Staff", disabled: false },
                  ]).map((field, index) => (
                    <motion.div
                      key={field.name}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.1 }}
                    >
                      <ModernInput
                        comp={field}
                        isSelect={field.type === "select"}
                        options={field.options || []}
                      />
                    </motion.div>
                  ))}

                  <div
                    onClick={() => setopenservice(true)}
                    className="cursor-pointer"
                  >
                    <TextField
                      fullWidth
                      disabled
                      label="Selected Services"
                      value={`${selectedServices.length} / ${
                        selector.services?.length || 0
                      } services selected`}
                      variant="outlined"
                      sx={{
                        cursor: "pointer",
                        "& .MuiInputBase-root": {
                          cursor: "pointer",
                        },
                      }}
                    />
                  </div>

                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="mt-4 pt-4 border-t"
                  >
                    <motion.div
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <Button
                        type="submit"
                        disabled={formSubmitting || isSubmitting || !isValid}
                        fullWidth
                        variant="contained"
                        endIcon={<MdArrowForward />}
                        sx={{
                          borderRadius: "12px",
                          py: 1.5,
                          background:
                            "linear-gradient(135deg, #0B469D 0%, #72a9fb 100%)",
                          textTransform: "none",
                          fontSize: "1rem",
                          fontWeight: 600,
                          boxShadow: "0 8px 25px rgba(11, 70, 157, 0.3)",
                          "&:hover": {
                            background:
                              "linear-gradient(135deg, #0a3d7a 0%, #5a8fd8 100%)",
                            boxShadow: "0 12px 35px rgba(11, 70, 157, 0.4)",
                          },
                        }}
                      >
                        {formSubmitting || isSubmitting
                          ? "Adding Staff..."
                          : "Add Staff Member"}
                      </Button>
                    </motion.div>
                  </motion.div>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </motion.div>
      </Dialog>
    </>
  );
};

const ProfilePopup = ({ closePopup }) => {
  const selector = useSelector((state) => state.business);
  const dispatch = useDispatch();
  const categoryState = useSelector((state) => state.categories);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getCategories(dispatch);
  }, [dispatch]);

  const submitService = async (values) => {
    setIsSubmitting(true);
    await completeProfileDashboardGoogle(dispatch, {
      ...values,
      owner: selector.details?.owner,
    });
    setIsSubmitting(false);
    closePopup();
  };

  return (
    <Dialog
      open={true}
      onClose={closePopup}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "24px",
          backgroundColor: "rgba(255, 255, 255, 0.98)",
          backdropFilter: "blur(20px)",
        },
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
      >
        <DialogTitle className="flex items-center justify-between border-b pb-3">
          <Typography variant="h5" className="font-bold">
            Complete Your Business Profile
          </Typography>
          <IconButton onClick={closePopup} sx={{ color: "#666" }}>
            <MdClose />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Formik
            initialValues={initialValuesUpdateProfileGoogle}
            validationSchema={validationSchemaUpdateProfileGoogle}
            onSubmit={submitService}
          >
            {({ isSubmitting: formSubmitting, isValid }) => (
              <Form className="flex flex-col gap-4">
                {feildsUpdateProfileGoogle(
                  categoryState.data
                    ? categoryState.data.map((e) => ({
                        value: e.preset_id,
                        label: e.business_type,
                        disabled: false,
                      }))
                    : []
                ).map((field, index) => (
                  <motion.div
                    key={field.name}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <ModernInput
                      comp={field}
                      isSelect={field.type === "select"}
                      options={field.options || []}
                    />
                  </motion.div>
                ))}

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                  className="mt-4 pt-4 border-t"
                >
                  <motion.div
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <Button
                      type="submit"
                      disabled={formSubmitting || isSubmitting || !isValid}
                      fullWidth
                      variant="contained"
                      endIcon={<MdArrowForward />}
                      sx={{
                        borderRadius: "12px",
                        py: 1.5,
                        background:
                          "linear-gradient(135deg, #0B469D 0%, #72a9fb 100%)",
                        textTransform: "none",
                        fontSize: "1rem",
                        fontWeight: 600,
                        boxShadow: "0 8px 25px rgba(11, 70, 157, 0.3)",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #0a3d7a 0%, #5a8fd8 100%)",
                          boxShadow: "0 12px 35px rgba(11, 70, 157, 0.4)",
                        },
                      }}
                    >
                      {formSubmitting || isSubmitting
                        ? "Saving Profile..."
                        : "Complete Profile"}
                    </Button>
                  </motion.div>
                </motion.div>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </motion.div>
    </Dialog>
  );
};

export default CompleteSetupGoogle;
